// eslint-disable-next-line no-shadow
export enum MapViewDirections {
  UP = "UP",
  DOWN = "DOWN",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

// eslint-disable-next-line no-shadow
export enum MapViewTypes {
  LIFT = "LIFT",
  MAP = "MAP",
  ESCALATOR = "ESCALATOR",
  MOVINGWALK = "MOVINGWALK",
}

export interface MapViewPin {
  id: string;
  text: string;
  direction: MapViewDirections;
  x?: number;
  y?: number;
  type: MapViewTypes;
}

export interface MapViewInterface {
  [key: string]: any; // Index signature
  id?: string;
  name: string;
  offline_url?: string;
  map_img_url?: string;
  waypoints?: any[];
  group_waypoints?: any[];
  bank_waypoints?: any[];
  has_display_view?: boolean;
  is_main?: boolean;
  orgId?: string;
}

export interface MapViewPin2Interface {
  boxSize: "xs" | "sm" | "md" | "lg" | "xl";
  fault: boolean;
  isEscalator: boolean;
  rowDirection: "top" | "left" | "bottom" | "right";
  pinDirection: "horizontal" | "vertical";
  icon: any;
  iconHeight: number;
  iconWidth: number;
}
